import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { HorusBtnDirective } from "../../../../shared/directives/horus-btn.directive";
import { TimelineDetailData } from "../../models/timeline-detail.model";

@Component({
  selector: "app-timeline-detail-drawer",
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    HorusBtnDirective,
  ],
  template: `
    <div class="timeline-detail-drawer" data-testid="timeline-detail-drawer">
      <div class="timeline-detail-drawer__header">
        <h2 class="timeline-detail-drawer__title">Detalle del estado</h2>
        <button
          class="timeline-detail-drawer__close"
          (click)="onClose()"
          data-testid="timeline-detail-drawer-close"
        >
          <mat-icon fontSet="material-icons-outlined">close</mat-icon>
        </button>
      </div>

      <div class="timeline-detail-drawer__content">
        <div class="timeline-detail-drawer__badge">
          {{ data.step.title }}
        </div>

        <div class="detail-card">
          <div class="detail-card__row">
            <span class="detail-card__label">FECHA</span>
            <span class="detail-card__value">{{ data.step.date | date: 'dd/MM/yy' }} {{ data.step.date | date: 'HH:mm' }}</span>
          </div>

          <div class="detail-card__row">
            <span class="detail-card__label">USUARIO</span>
            <span class="detail-card__value">{{ data.step.createdBy || '-' }}</span>
          </div>

          <div class="detail-card__row">
            <span class="detail-card__label">MOTIVO</span>
            <span class="detail-card__value detail-card__value--small">{{ data.step.subStatus || '-' }}</span>
          </div>

          @if (data.step.observation) {
            <div class="detail-card__row">
              <span class="detail-card__label">DETALLE</span>
              <span class="detail-card__value detail-card__value--small">{{ data.step.observation }}</span>
            </div>
          }
        </div>
      </div>

      <div class="timeline-detail-drawer__footer">
        <button
          horusBtn
          horusBtnVariant="outline-default"
          horusBtnSize="md"
          class="w-full"
          (click)="onClose()"
        >
          CERRAR
        </button>
      </div>
    </div>
  `,
  styleUrl: "./timeline-detail-drawer.component.scss",
})
export class TimelineDetailDrawerComponent {
  data: TimelineDetailData = inject(MAT_DIALOG_DATA);

  onClose(): void {
    if (this.data.close) {
      this.data.close();
    }
  }
}
